webpackJsonp([273359567952216],{

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _widgetContainer = __webpack_require__(18);
	
	var _widgetContainer2 = _interopRequireDefault(_widgetContainer);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var seoTitle = "Li\xEAn h\u1EC7 - " + data.site.siteMetadata.title;
	  var url = data.site.siteMetadata.siteUrl + "/gioi-thieu/";
	
	  return Glamor.createElement(
	    "article",
	    null,
	    Glamor.createElement(_reactHelmet2.default, {
	      title: seoTitle,
	      meta: [{ name: 'description', content: "" + data.site.siteMetadata.description }, { name: 'keywords', content: "" + data.site.siteMetadata.keywords }]
	    }),
	    Glamor.createElement(
	      "h1",
	      null,
	      "Li\xEAn h\u1EC7"
	    ),
	    Glamor.createElement(
	      _widgetContainer2.default,
	      null,
	      Glamor.createElement(
	        "p",
	        null,
	        "N\u1EBFu c\xE1c b\u1EA1n c\xF3 g\xF3p \xFD hay th\u1EAFc m\u1EAFc g\xEC v\u1EC1 nh\u1EEFng ki\u1EBFn th\u1EE9c l\u1EADp tr\xECnh, thu\u1EADt to\xE1n m\xE0 c\u1EA7n li\xEAn l\u1EA1c v\u1EDBi m\xECnh, b\u1EA1n c\xF3 th\u1EC3 th\u1EF1c hi\u1EC7n m\u1ED9t trong c\xE1c c\xE1ch sau \u0111\xE2y:"
	      ),
	      Glamor.createElement(
	        "ul",
	        null,
	        Glamor.createElement(
	          "li",
	          null,
	          "Email: ",
	          data.site.siteMetadata.email
	        ),
	        Glamor.createElement(
	          "li",
	          null,
	          "Facebook Fanpage: ",
	          Glamor.createElement(
	            "a",
	            { href: data.site.siteMetadata.fanpage },
	            "\xD4n luy\u1EC7n thu\u1EADt to\xE1n"
	          )
	        ),
	        Glamor.createElement(
	          "li",
	          null,
	          "Facebook Group: ",
	          Glamor.createElement(
	            "a",
	            { href: data.site.siteMetadata.fbGroup },
	            "H\u1ECFi \u0111\xE1p thu\u1EADt to\xE1n VN"
	          )
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-lien-he-js-c13b0c4f8f546c9c569e.js